import {Nullable} from '../../../../../app/TypeHelpers'
import {HOURS, RESERVATION_TIME_UNIT_MINUTES} from '../../../../../CodeMaster'
import * as React from 'react'
import {LeftRowFlexContainer, RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {Box} from '@mui/material'
import {calcSelectableHoursAndUpperLimit} from './helpers'
import {EndOfTimeZoneInputWithMaxTime} from './EndOfTimeZoneInputWithMaxTime'
import equal from 'fast-deep-equal'
import {valueStringOrEmpty} from '../../../../../codeMasterHelper/CodeMasterHelper'

export interface TimeZoneInputWithMaxTimeProps {
    startHour: Nullable<HOURS>
    endHour: Nullable<HOURS>
    minute: Nullable<RESERVATION_TIME_UNIT_MINUTES>
    selectableEndHour: Nullable<HOURS>
    maxReservationTime: Nullable<number>
    onChangeEndHour: (endHour: HOURS) => void
    onChangeMaxTime: (maxTime: Nullable<number>) => void
    disabledEndHour?: boolean
}

export const TimeZoneInputWithMaxTime: React.FC<TimeZoneInputWithMaxTimeProps> = React.memo(props => {
    const {startHour, endHour, minute, selectableEndHour, maxReservationTime} = props
    const {maxReservationTimeUpperLimit, selectableHours} =
        calcSelectableHoursAndUpperLimit(startHour, endHour, selectableEndHour)

    return (
        <LeftRowFlexContainer>
            <StartOfTimeZone hour={startHour} minute={minute}/>
            <Box display="flex" justifyContent="center" minWidth={'24px'}>〜</Box>
            <EndOfTimeZoneInputWithMaxTime
                hour={endHour}
                minute={minute}
                selectableHours={selectableHours}
                maxReservationTime={maxReservationTime}
                maxReservationTimeUpperLimit={maxReservationTimeUpperLimit}
                onChangeEndHour={props.onChangeEndHour}
                onChangeMaxTime={props.onChangeMaxTime}
                disabledEndHour={props.disabledEndHour}
            />
        </LeftRowFlexContainer>)
}, (prevProps, nextProps) => (prevProps === nextProps || equal(prevProps, nextProps)))

interface StartOfTimeZoneInputProps {
    hour: Nullable<HOURS>
    minute: Nullable<RESERVATION_TIME_UNIT_MINUTES>
}

const StartOfTimeZone: React.FC<StartOfTimeZoneInputProps> = React.memo(props => {
    const hourValue: string = valueStringOrEmpty(props.hour)
    const minuteValue: string = valueStringOrEmpty(props.minute)
    return <RowFlexContainer>
        <Box display={'flex'} justifyContent="flex-end" minWidth={'144px'}>
            {hourValue}時
            <Box ml={'4px'}/>
            {minuteValue}分
        </Box>
    </RowFlexContainer>
}, (prevProps, nextProps) => (prevProps === nextProps || equal(prevProps, nextProps)))
